import React, { Component } from 'react';

class AboutLeQG extends Component {
  render() {
    return (
      <section className={this.props.background} id="about">
        <div className="container mt-5 mb-5">
          <div className="row pt-2 pb-2">
            <span className="col-12 txt-bold-40px txt-blue txt-uppercase">Restaurant & Wine Bar</span>
            <p className="col-12 txt-thin">
              Éclos en 2014, LEQG jouit d'une vue sur mer exceptionnelle, un service excellent et un accueil inégalé de son
              équipe dans un cadre contemporain et chaleureux. Aux beaux jours, sa terrasse vous offre un espace calme et
              détaché des bruits de la rue, un endroit idéal pour profiter de la journée. A la croisée des chemins entre
              tradition et innovation, LEQG fait le bonheur des amoureux des douces saveurs méditerranéennes et ses spécialités
              que le chef sait accommoder en vous présentant des plats raffinés et délicieux.
            </p>
            <span className="col-12 txt-bold-40px txt-blue txt-uppercase">Luxury apartments</span>
            <p className="col-12 txt-thin">
              LEQG Luxury Apartments Sousse vous dispose des appartements de HAUT STANDING situés au bord de la mer à la
              location par jour, par semaine ou par mois et bénéficiant d'un service digne d'un hôtel 5 étoiles.
            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default AboutLeQG;



// WEBPACK FOOTER //
// ./src/components/leqg/AboutLeQG.js